import { render, staticRenderFns } from "./AppInstanceEditDialog.vue?vue&type=template&id=53f23a86"
import script from "./AppInstanceEditDialog.vue?vue&type=script&lang=js"
export * from "./AppInstanceEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports